module.exports = __webpack_public_path__ + "img/030-architecture.bbfeb878.svg";